import { render } from "./ShowConnection.vue?vue&type=template&id=5df87774"
import script from "./ShowConnection.vue?vue&type=script&lang=js"
export * from "./ShowConnection.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__